
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
    import {useRouter, useRoute} from "vue-router";
    import {useStore} from "@/store";
    import  reportMsgUt from "@/util/reportMsg";


    interface State {
        isNoDefect: ComputedRef<boolean>; // 是否为无火烧无泡水无重大事故的车
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        channelType: string;
        templateCode: string;
        serviceGuarantee: string;
        reportMsg: object;
    }
    export default defineComponent({
        name: "ensureService",
        setup() {
            let state: State = reactive({
                isNoDefect: false as any,
                point: 'N' as any,
                channelType: '',
                templateCode: '',
                serviceGuarantee: '',
                reportMsg: {},
            })
            state.reportMsg = reportMsgUt;
            let store = useStore()
            // 获取路由器实例
            const router = useRouter()
            const {query} = useRoute();
            state.channelType = `${query.channelType}` || '';
            state.templateCode = `${query.templateCode}` || '';
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {isAccident, isFire, isWater, accidentFlag, reportConfigInfo} = data
                state.isNoDefect = computed(() => {
                    return (accidentFlag === 0 || accidentFlag === 1 || isAccident === 0) && isFire === 0 && isWater === 0
                })
                state.point = computed(() => {
                    return state.isNoDefect ? 'N' : 'Y'
                })
                state.serviceGuarantee = reportConfigInfo ? reportConfigInfo.serviceGuarantee : '';
            })
            return {
                state,
                router,
                store
            }
        },
        methods: {
            toView(){
                this.store.dispatch('savePageScrollTop', window.scrollY);
                this.router.push({
                    path: '/tocV3ExplainFreeCheck',
                    query: {
                        channelType: this.state.channelType,
                        templateCode: this.state.templateCode,
                    }
                })
            },
            toAuth(){
                this.store.dispatch('savePageScrollTop', window.scrollY);
                this.router.push({
                    path: '/explainFreeAuth',
                    query: {
                        templateCode: this.state.templateCode
                    }
                })
            }
        }
    })
